/**
 * @generated SignedSource<<212e69dc1b620f5f5cce6a87788a60e1>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SessionStatus = "ACTIVE" | "DEBRIEFED" | "DEBRIEFING" | "ENDED" | "FAILED" | "%future added value";
export type SessionGateQuery$variables = Record<PropertyKey, never>;
export type SessionGateQuery$data = {
  readonly me: {
    readonly learner: {
      readonly id: string;
      readonly lastSession: {
        readonly id: string;
        readonly status: SessionStatus;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type SessionGateQuery = {
  response: SessionGateQuery$data;
  variables: SessionGateQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Account",
    "kind": "LinkedField",
    "name": "me",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Learner",
        "kind": "LinkedField",
        "name": "learner",
        "plural": false,
        "selections": [
          (v0/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Session",
            "kind": "LinkedField",
            "name": "lastSession",
            "plural": false,
            "selections": [
              (v0/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SessionGateQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SessionGateQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "cdd46e70ae55e86f4938465ea818d528",
    "id": null,
    "metadata": {},
    "name": "SessionGateQuery",
    "operationKind": "query",
    "text": "query SessionGateQuery {\n  me {\n    learner {\n      id\n      lastSession {\n        id\n        status\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5de3060d284a94520d497f062bd9ee0c";

export default node;
